// Create formatters once and reuse them
export const imxFormatter = new Intl.NumberFormat("en-US", {
  style: "decimal",
  minimumFractionDigits: 0,
  maximumFractionDigits: 3,
});

export const percentFormatter = new Intl.NumberFormat("en-US", {
  style: "percent",
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export const formatDateToMonthDay = (dateString: string): string => {
  const [month, day] = dateString.split(",")[0].split(" ");
  return `${month} ${day?.replace(/\D/g, "")}`;
};
